import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// Archivo: a grotesque with real weight at the top end, which is what the
// Printoman wordmark is built from. Variable, latin subset only (unicode-range
// keeps the other subsets from ever being fetched), 34 KB for weights 100-900,
// `font-display: swap` so text paints immediately in the system stack and
// re-renders when it lands. Headings only — body stays on the system font,
// because a checkout on an Indian mobile network should not wait on webfonts.
import '@fontsource-variable/archivo/wght.css';

import './index.css';

const container = document.getElementById('root');
if (!container) {
  // A missing #root means index.html and this entry point disagree — a build
  // problem, not a runtime condition, so fail loudly instead of silently.
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  // StrictMode double-invokes effects in development. That is on purpose: it
  // surfaces missing cleanup (event listeners, aborted fetches, focus traps)
  // during development instead of as a leak in production.
  <StrictMode>
    <App />
  </StrictMode>,
);
